<template>
    <div>
        <v-dialog v-model="dialog" width="95vw" persistent>
            <v-card class="mx-auto d-flex flex-column user-select-none w-100" min-height="70vh" :loading="loading > 0">
                <v-toolbar color="white" class="flex-grow-0">
                    <template v-for="(item, index) in dirStack" :key="index">
                        <v-icon>chevron_left</v-icon>
                        <v-btn variant="text" @click="index != dirStack.length - 1 ? (currentDir = [item]) : false" class="text-none">{{ item.name }}</v-btn>
                    </template>
                    <v-spacer></v-spacer>
                    <v-btn title="بازگشت" v-if="dirStack.length > 1" icon variant="text" @click="currentDir = [dirStack.at(-2)]">
                        <v-img width="30" height="30" :src="icons.backwardIcon"></v-img>
                    </v-btn>
                    <v-menu v-model="newFolderPopper" :close-on-content-click="false">
                        <template #activator="{ props }">
                            <v-btn variant="text" icon v-bind="props" title="ساخت پوشه">
                                <v-img width="30" height="30" :src="icons.newFolderIcon"></v-img>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-text>
                                <v-text-field label="نام پوشه" v-model="newFolderName" hide-details></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="error" variant="text" @click="newFolderPopper = false">انصراف</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="success" :disabled="!newFolderName" @click="makeDir">ایجاد پوشه</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                    <v-btn @click="uploadMod = !uploadMod" icon variant="text" title="آپلود فایل">
                        <v-img width="30" height="30" :src="icons.uploadIcon"></v-img>
                    </v-btn>
                    <v-btn @click="this.dialog = false" icon variant="text" title="بستن">
                        <v-img width="30" height="30" :src="icons.closeIcon"></v-img>
                    </v-btn>
                </v-toolbar>
                <v-row no-gutters class="flex-grow-1 overflow-hidden">
                    <v-col class="h-100 d-none d-md-block" cols="auto">
                        <v-card tile width="250" color="h-100 overflow-y-auto">
                            <!-- open-on-click -->
                            <v-treeview
                                :items="objects"
                                v-model:opened="oppenedTree"
                                v-model:activated="currentDir"
                                collapse-icon=""
                                expand-icon=""
                                fluid
                                density="compact"
                                active-strategy="single-independent"
                                mandatory
                                slim
                                item-value="id"
                                item-title="name"
                                item-children="subdirectories"
                                return-object
                                activatable
                            >
                                <template #label="{ item, active }">
                                    <div @click="active ? $event.stopPropagation() : null">{{ item.name }}</div>
                                </template>
                                <template #prepend="{ item, open }">
                                    <v-btn :loading="item.loading" @click="toggleDir(item, open); $event.stopPropagation()" variant="text" icon>
                                        <v-img width="24" height="24" :src="open ? icons.folderOpenIcon : icons.folderCloseIcon"></v-img>
                                    </v-btn>
                                </template>
                            </v-treeview>
                        </v-card>
                    </v-col>
                    <v-divider class="ma-0 d-none d-md-block" vertical></v-divider>
                    <v-col class="h-100">
                        <v-card tile class="h-100 overflow-y-auto">
                            <v-fade-transition>
                                <v-card-text v-show="uploadMod">
                                    <file-input
                                        class="pa-3"
                                        :style="{border: '3px gray dotted'}"
                                        :text="`<p class='text-meta font-weight-bold text-center mb-0 py-7'>آپلود فایل‌</p>`"
                                        :types="['*']"
                                        :mimeTypes="[]"
                                        :size="100 * 1048576"
                                        :maxFiles="100"
                                        type="file"
                                        ref="files"
                                    ></file-input>
                                    <div class="mt-sm-5 mt-1">
                                        <v-btn @click="makeUpload" class="text-white " color="success" :disabled="!$refs.files || !$refs.files.getValidFiles().length" :loading="uploadButtonLoading">آپلود</v-btn>
                                        <v-btn @click="uploadMod = false" class="ms-2 " color="error" variant="text" :disabled="uploadButtonLoading">انصراف</v-btn>
                                    </div>
                                </v-card-text>
                            </v-fade-transition>
                            <v-card-text v-if="currentDir[0]?.children?.length">
                                <v-item-group>
                                    <v-row>
                                        <v-col v-for="(item, index) in currentDir[0].children" :key="index" cols="auto" class="position-relative">
                                            <v-item #default="{ isSelected }">
                                                <v-hover open-delay="50" close-delay="150" #default="{ isHovering, props }">
                                                    <v-card v-bind="props" @dblclick="item.type ? currentDir = [item] : $text.copy(public_url + item.path)" @click="activeItem = item;" :color="isSelected || isHovering ? 'grey-lighten-2' : 'transparent'" class="d-flex user-select-none align-center justify-space-between flex-column" :style="{width: '150px', height: '150px'}" style="transition: all 0.2s">
                                                        <div class="d-flex align-center flex-grow-1">
                                                            <v-img
                                                                v-if="item.meta_data?.thumbnail_path || item.type"
                                                                :src="item.type ? icons.folderIcon : (public_url + item.meta_data.thumbnail_path)"
                                                                :width="item.type ? '64' : '90'"
                                                                :aspect-ratio="1/1"
                                                            ></v-img>
                                                            <div v-else :class="`fi-round-md fi-size-md fi fi-${item.meta_data?.extension}`"><div class="fi-content">{{item.meta_data?.extension}}</div></div>
                                                        </div>
                                                        <div class="position-relative w-100 overflow-hidden" :style="{height: '44px'}">
                                                            <v-fade-transition leave-absolute>
                                                                <div v-if="activeItem.id == item.id" class="justify-center d-flex px-1">
                                                                    <v-btn class="bg-grey-lighten-3 me-1 rounded" width="28" height="28" variant="text" icon @click="makeDelete"><v-img width="20" height="20" :src="icons.trashIcon"></v-img></v-btn>
                                                                    <v-btn class="bg-grey-lighten-3 me-1 rounded" width="28" height="28" variant="text" icon v-if="!item.type" @click="$text.copy(public_url + activeItem.path)"><v-img width="20" height="20" :src="icons.copyIcon"></v-img></v-btn>
                                                                    <v-btn class="flex-grow-1" color="secondary" v-if="item.meta_data?.thumbnail_path" @click="$emit('choose', public_url + activeItem.path)">انتخاب</v-btn>
                                                                </div>
                                                                <p v-else class="file-manager-filename text-center ma-0 px-1">{{ item.name }}{{ item.meta_data?.extension ? '.' + item.meta_data?.extension : '' }}</p>
                                                            </v-fade-transition>
                                                        </div>
                                                    </v-card>
                                                </v-hover>
                                            </v-item>
                                        </v-col>
                                    </v-row>
                                </v-item-group>
                            </v-card-text>
                            <v-card-text v-else-if="!loading" class="h-100 d-flex justify-center align-center text-grey py-5">موردی پیدا نشد</v-card-text>
                        </v-card>
                    </v-col>
                    <v-divider class="ma-0 d-none d-lg-block" vertical></v-divider>
                    <v-col class="h-100 d-none d-lg-block" cols="auto">
                        <v-card v-if="activeItem" tile width="250" color="h-100 overflow-y-auto">
                            <v-card-text>
                                <p>جزئیات پیوست</p>
                                <p class="text-small mb-1 mt-4">عنوان {{ activeItem.type ? 'پوشه' : 'فایل' }}:</p>
                                <p dir="ltr" class="text-small mb-1 text-end">{{ activeItem.name }}{{ activeItem.meta_data?.extension ? '.' + activeItem.meta_data.extension : '' }}</p>
                                <p class="text-small mb-1" v-if="activeItem.meta_data?.size">حجم فایل:</p>
                                <p dir="ltr" class="text-small mb-1 text-end" v-if="activeItem.meta_data?.size">{{ formatBytes(activeItem.meta_data.size) }}</p>
                                <p class="text-small mb-1" v-if="activeItem.meta_data?.dimentions">ابعاد تصویر:</p>
                                <p dir="ltr" class="text-small mb-1 text-end" v-if="activeItem.meta_data?.dimentions">{{ activeItem.meta_data.dimentions.width + ' x ' + activeItem.meta_data.dimentions.height }}</p>
                                <p class="text-small mb-1" v-if="activeItem.type === 0">نشانی فایل:</p>
                                <p dir="ltr" class="text-small mb-1 text-end cursor-pointer" @click="$text.copy(public_url + activeItem.path)" v-if="activeItem.type === 0">{{ public_url + activeItem.path }}</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import uploadIcon from './assets/icons/upload.svg';
import folderIcon from './assets/icons/folder.svg';
import folderCloseIcon from './assets/icons/folder-close.svg';
import folderOpenIcon from './assets/icons/folder-open.svg';
import newFolderIcon from './assets/icons/new-folder.svg';
import backwardIcon from './assets/icons/backward.svg';
import closeIcon from './assets/icons/close.svg';
import trashIcon from './assets/icons/trash.svg';
import copyIcon from './assets/icons/copy.svg';
import { VTreeview } from 'vuetify/labs/VTreeview'
export default {
    components: {
        VTreeview,
    },
    data() {
        return {
            dialog: false,
            newFolderPopper: false,
            newFolderName: null,
            oppenedTree: [],
            activeItem: {},
            objects: [{
                id: 1,
                loading: false,
                name: 'شاخه اصلی',
                children: [],
                subdirectories: []
            }],
            currentDir: [],
            dirStack: [],
            icons: {
                uploadIcon,
                folderIcon,
                folderCloseIcon,
                folderOpenIcon,
                newFolderIcon,
                backwardIcon,
                closeIcon,
                trashIcon,
                copyIcon
            },
            public_url: false,
            loading: 0,
            uploadMod: false,
            uploadButtonLoading: false,
        };
    },
    methods: {
        open() {
          this.dialog = true;
        },
        close() {
          this.dialog = false;
        },
        async toggleDir(item, open) {
            if(!item.loaded) {
                item.loading = true;
                await this.loadDir(item);
                item.loading = false;
            }
            open ? this.oppenedTree.splice(this.oppenedTree.indexOf(item), 1) : this.oppenedTree.push(item)
        },
        async loadDir(item = false) {
            let res = await this.$fileGet(item ? item.id : this.currentDir[0].id, {perPage: 999});
            if(res.status == 'OK') {
                if(!this.public_url)
                    this.public_url = res.public_url;
                if(item) {
                    item.children = res.data.map(x => {return {...x, children: [], subdirectories: [], loaded: false, loading: false}});
                    item.subdirectories = item.children.filter(x => x.type);
                    item.loaded = true;
                } else {
                    this.currentDir[0].children = res.data.map(x => {return {...x, children: [], subdirectories: [], loaded: false, loading: false}});
                    this.currentDir[0].subdirectories = this.currentDir[0].children.filter(x => x.type);
                    this.currentDir[0].loaded = true;
                }
            }
        },
        async makeDir() {
            this.loading = true;
            await this.$fileStore({parent_id: this.currentDir[0].id, name: this.newFolderName});
            this.newFolderPopper = false;
            this.newFolderName = null;
            await this.loadDir();
            this.loading = false;
        },
        async makeDelete() {
            this.$confirm(
                `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، ${this.activeItem.name} حذف خواهد شد.</p>`,
                { buttonTrueText: "حذف", buttonTrueColor: "error" }
            ).then(async (res) => {
                if (res){
                    this.loading = true;
                    await this.$fileDelete(this.activeItem.id);
                    this.activeItem = this.currentDir[0];
                    await this.loadDir();
                    this.loading = false;
                }
            });
        },
        async makeUpload() {
            this.uploadButtonLoading = true;
            let forms = [];
            this.$refs.files.getValidFiles().forEach(async el => {
                let formData = new FormData();
                formData.append('parent_id', this.currentDir[0].id);
                formData.append('file', el.file);
                forms.push(formData);
            });
            await Promise.all(forms.map(form => this.$fileStore(form)))
            this.uploadButtonLoading = false;
            this.uploadMod = false;
            this.$refs.files.removeAllFiles();
            this.loading = true;
            await this.loadDir();
            this.loading = false;
        },
        formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 bytes';
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        findDir(item, target) {
            if(item.id == target.id)
                return [item];
            for (let i = 0; i < item.subdirectories.length; i++) {
                let res = this.findDir(item.subdirectories[i], target);
                if(res != false) {
                    res.push(item);
                    return res;
                }
            }
            return false;
        }
    },
    watch: {
        async currentDir() {
            this.dirStack = this.findDir(this.objects[0], this.currentDir[0]);
            this.dirStack.reverse();
            if(!this.currentDir[0].loaded) {
                this.loading = true;
                await this.loadDir();
                this.loading = false;
            }
            this.dirStack.forEach(el => this.oppenedTree.indexOf(el) == -1 ? this.oppenedTree.push(el) : '');
            this.activeItem = this.currentDir[0];
        },
    },
    async mounted() {
        this.currentDir = [this.objects[0]];
    }
};
</script>

<style lang="scss" scoped>
@import './assets/css/icons.css';
.file-manager-treeview :deep(.v-list-item-action) {
    opacity: 0;
}
.file-manager-treeview {
    margin-right: -24px;
}
.file-manager-filename {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-wrap: break-word;
    white-space: pre-wrap;
    word-break: break-word;
    line-clamp: 2;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
}
</style>
